export enum IssuesSupportedActions {
    setAgentActionAuth = "Set Agent Action Auth",
    quarantineUser = "QUARANTINE USER",
    contactDataOwner = "Contact Data Owner",
    routeToSOC = "Route to SOC",
    excludeFromRAG = "Exclude from RAG",
    restrictTriggerDomains = "Restrict Trigger Domains",
    contactOwner = "Contact Owner",
    disableAIAgentAction = "Disable AI Agent Action",
    deleteConnection = "Delete Connection",
    maskCredentials = "Mask Credentials",
    removeAccess = "Remove Access",
}
